module.exports = __webpack_public_path__ + "img/mingyong32.ba79833f.png";